import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

// router config
Vue.config.productionTip = false
import VueRouter from 'vue-router'
import { Routes } from './Routes'
Vue.use(VueRouter)
const router = new VueRouter({
    routes: Routes,
    mode: 'history',
    linkExactActiveClass: "active",
})

// axios config
import axios from "axios";

// axios.defaults.baseURL = 'http://192.168.1.7:3000/admin';
axios.defaults.baseURL = 'https://api.tarazafzar.ir/admin';

// Vue.prototype.$hostname = 'https://superto-server.iran.liara.run'
axios.defaults.headers.common['token'] = localStorage.getItem("token") || ""

// vuex
import { store } from './Store.js'

// date picker
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    format: 'YYYY-MM-DD HH:mm',
    displayFormat: 'jYYYY-jMM-jDD HH:mm',
    editable: false,
    clearable: true,
    inputClass: 'form-control my-custom-class-name',
    placeholder: 'تاریخ مورد نظر را انتخاب کنید',
    altFormat: 'YYYY-MM-DD HH:mm',
    color: '#3F51B5',
    autoSubmit: true,
    
  }
});


new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
